import React from 'react';

let videoReactModule = null;
let videoReactPromise = null;

function getNamedExport(module, exportName) {
  if (!module) {
    return null;
  }

  if (module[exportName]) {
    return module[exportName];
  }

  if (module.default && module.default[exportName]) {
    return module.default[exportName];
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[lazyVideoReact] 未在 video-react 模块中找到导出：${exportName}`);
  }

  return null;
}

export function loadVideoReact() {
  if (videoReactModule) {
    return Promise.resolve(videoReactModule);
  }

  if (videoReactPromise) {
    return videoReactPromise;
  }

  // JS 与 CSS 一起随 chunk 懒加载，避免 video-react 的样式进入主包。
  videoReactPromise = Promise.all([
    import(/* webpackChunkName: "video-react" */ 'video-react'),
    import(/* webpackChunkName: "video-react" */ 'video-react/dist/video-react.css')
  ])
    .then(([module]) => {
      videoReactModule = module;
      return module;
    })
    .catch((error) => {
      videoReactPromise = null;
      throw error;
    });

  return videoReactPromise;
}

export function preloadVideoReact() {
  loadVideoReact().catch(() => {});
}

/**
 * 仅适用于“组件首次可短暂返回 null 不会触发业务回归”的场景。
 * 像 BannerCell 这种不依赖 Player ref/实例方法的地方可以安全使用。
 */
export function createLazyVideoReactComponent(exportName) {
  class LazyVideoReactComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        Comp: videoReactModule ? getNamedExport(videoReactModule, exportName) : null
      };
      this.mounted = false;
    }

    componentDidMount() {
      if (this.state.Comp) {
        return;
      }

      this.mounted = true;
      loadVideoReact()
        .then((module) => {
          if (!this.mounted) {
            return;
          }

          const Comp = getNamedExport(module, exportName);

          if (Comp) {
            this.setState({ Comp });
          }
        })
        .catch(() => {});
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      const { Comp } = this.state;
      const { forwardedRef, children, ...rest } = this.props;

      if (!Comp) {
        return null;
      }

      return (
        <Comp ref={forwardedRef} {...rest}>
          {children}
        </Comp>
      );
    }
  }

  const ForwardedComponent = React.forwardRef((props, ref) => {
    return <LazyVideoReactComponent {...props} forwardedRef={ref} />;
  });

  ForwardedComponent.displayName = `LazyVideoReact(${exportName})`;

  return ForwardedComponent;
}



// WEBPACK FOOTER //
// ./src/utils/lazyLoad/lazyVideoReact.js